/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto } from '../../models/customer-dto';
import { OtpConfirmDto } from '../../models/otp-confirm-dto';

export interface ConfirmPhoneNumberStep2$Params {
      body: OtpConfirmDto
}

export function confirmPhoneNumberStep2(http: HttpClient, rootUrl: string, params: ConfirmPhoneNumberStep2$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerDto>> {
  const rb = new RequestBuilder(rootUrl, confirmPhoneNumberStep2.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerDto>;
    })
  );
}

confirmPhoneNumberStep2.PATH = '/api/v1/customer/confirm-phone-number/confirm';
